import React, { useState } from "react";

import { Button as AntButton, Input } from "antd";
import ModalOriginal from "components/Modal";
import { DialogWrapper as DialogWrapperOriginal } from "components/containers";
import { TitleH2 } from "components/generic";
import { useNotifier } from "context/ContextNotifier";
import { useShowInterest } from "../../API/queries/studentApiQueries";
import { IHouse, IUserShort } from "../../interfaces/interfaces";
import { useContextHospi } from "../../context/ContextHospi";
import { InfoBox as InfoBoxOriginal } from "../InfoBox/InfoBox";
import styled from "styled-components/macro";
import { useTranslation } from "react-i18next";

const InfoBox = styled(InfoBoxOriginal)`
  background: #f4f4f4;
  color: #333333;
`;

const Modal = styled(ModalOriginal)`
  & > section {
    background: white;

    @media ${(props) => props.theme.media.tablet} {
      width: 90%;
    }

    @media ${(props) => props.theme.media.phone} {
      width: 90%;
    }
  }

  ${InfoBox} {
    .anticon {
      display: none;
    }
  }
`;

const InfoBoxTitle = styled.div`
  font-weight: ${(p) => p.theme.font.weightMedium};
  font-size: 18px;

  margin-bottom: 16px;
`;

const DialogWrapper = styled(DialogWrapperOriginal)``;
const Footer = styled.div`
  display: flex;
  gap: 10px;
`;

export const ShowInterestModal: React.FC<{
  host: Partial<IUserShort>;
  house: Partial<IHouse>;
  isShow: boolean;
  onClose: () => void;
  onSent: () => void;
}> = ({ host, house, isShow, onClose, onSent }) => {
  const showInterest = useShowInterest();
  const notifier = useNotifier();
  const [message, setMessage] = useState("");
  const { userProfile } = useContextHospi();
  const { t } = useTranslation("hostrooms");

  const handleShowInterest = () => {
    showInterest.mutate(
      {
        match: {
          host_id: host.user_id!,
          house_id: house.house_id!,
          student_id: userProfile?.user_id!
        },
        message
      },
      {
        onSuccess: () => {
          notifier.success({
            message: t("roomCard.chatRequestSent")
          });
          setMessage("");
          onSent();
        }
      }
    );
  };

  return (
    <Modal handleClose={onClose} isShow={isShow}>
      <DialogWrapper>
        <TitleH2>{t("showInterestModal.sendChatRequest")}</TitleH2>
        <div>
          <InfoBox>
            <InfoBoxTitle>{t("showInterestModal.howItWorks")}</InfoBoxTitle>
            <div>{t("showInterestModal.explanation")}</div>
          </InfoBox>
        </div>
        <Footer>
          <Input.TextArea
            size="large"
            autoSize
            placeholder={t("showInterestModal.welcomeMessage")}
            disabled={showInterest.isLoading}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
          />
          <AntButton
            type={"primary"}
            disabled={message.length === 0}
            onClick={() => handleShowInterest()}
            loading={showInterest.isLoading}
            size="large"
          >
            {t("showInterestModal.send")}
          </AntButton>
        </Footer>
      </DialogWrapper>
    </Modal>
  );
};
